import { Button, Grid2, IconButton, Stack, styled } from "@mui/material";

export const PrimaryGranularityButton = styled(Button)(({ theme, active, disabled }) => ({
    padding: '6px 8px',
    backgroundColor: active ? '#FFFFFF' : '#F9F9F9',
    boxShadow: active ? "2px 2px 10px 0px rgba(151, 151, 151, 0.12)" : "",

    '&:hover': {
        backgroundColor: active ? '' : '#F9F9F9',

        '& .MuiTypography-root': {
            color: disabled ? '#A2A2A2' : '#4D44D8',
        },
    },

    '&.Mui-disabled': {
        cursor: "not-allowed !important",
        pointerEvents: "inherit !important",
    },

    '& .MuiTypography-root': {
        color: active ? '#4D44D8' : (disabled ? '#A2A2A2' : '#686868'),
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: active ? 500 : 400,
    },
}))

export const SecondaryGranularityButton = styled(IconButton)(({ theme, active, disabled }) => ({
    padding: '6px 8px',
    backgroundColor: active ? '#FFFFFF' : '#F9F9F9',
    borderRadius: '6px',
    boxShadow: active ? "2px 2px 10px 0px rgba(151, 151, 151, 0.12)" : "",

    '&:hover': {
        backgroundColor: active ? '#FFFFFF' : '#F9F9F9',

        '& .MuiSvgIcon-root': {
            color: disabled ? '#A2A2A2' : '#4D44D8',
        },
    },

    '&.Mui-disabled': {
        cursor: "not-allowed !important",
        pointerEvents: "inherit !important",
    },

    '& .MuiSvgIcon-root': {
        color: active ? '#4D44D8' : (disabled ? '#A2A2A2' : '#686868'),
        fontWeight: active ? 500 : 400,
    },
}))

export const IDDisplayBox = styled(Grid2)(({ theme }) => ({
    'padding': '8px 12px',
    'borderRadius': '4px',
    'background': '#F9F9F9',
    'display': 'flex',
    'alignItems': 'center',
    'gap': '8px',

    '& .MuiTypography-root': {
        lineHeight: '16px'
    },
    '& .MuiBox-root .MuiTypography-root:nth-of-type(2)': {
        fontWeight: 500,
    },
}))


export const BatteryStructureNodeItem = styled(Stack)(({ selected, highlight, isLeaf, onClick }) => ({
    backgroundColor: selected ? "#EFF0FF" : "inherit",
    borderRadius: 4,
    cursor: onClick ? "pointer" : "auto",
    "&:hover": {
        backgroundColor: "#F9F9F9",
    },
    "& .icon-button": {
        width: 24,
        height: 24,
        background: "none",
    },
    "& .MuiTypography-root": {
        color: (selected || highlight) && !isLeaf ? "#4D44D8" : "inherit",
        fontWeight: selected ? 500 : "inherit",
    },
}));


export const DigitalTwinTabContainer = styled(Grid2)(({ theme, height }) => ({
    overflow: 'hidden',
    overflowX: 'hidden',
    padding: '0px',
    paddingTop: '16px',
    marginBottom: '2%',
    // height: height || 'calc(100vh - 250px)'
}))